import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { HrActionText, HrGridContainer, HrPrimary } from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import styled from 'styled-components';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

const Grid = styled(HrGridContainer)`
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
    grid-template-columns: 1fr;
  }
`;

const Addbutton = styled(HrActionText)`
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px`};
  color: ${HrPrimary};
  margin-left: 32px !important;
  @media (max-width: 768px) {
    margin-left: 16px !important;
  }
`;

export const SectionNetworks = ({ vacancyRequirement, register, formState, postulant = {}, action }) => {
  const [t] = useTranslation();

  const { url_facebook, url_twitter, url_website } = postulant;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (url_facebook || url_website || url_twitter) {
      setShow(true);
    }
  }, [url_facebook, url_twitter, url_website]);

  const { fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <>
      <Grid>
        {action !== 'edit' && (
          <Input
            title={t('postulant.networks.url_linkedin')}
            placeholder={t('postulant.networks.placeholder.url_linkedin')}
            name='url_linkedin'
            type='text'
            register={register}
            formState={formState}
            validate={{
              required: vacancyRequirement.social_networks === 1,
              urlLinkedin: true
            }}
            errorPosition='bottom'
          />
        )}
      </Grid>

      {show && (
        <Grid flexDirection='column' alignItems='flex-end' flexWrap='nowrap'>
          <Input
            title={t('postulant.networks.url_facebook')}
            placeholder={t('postulant.networks.placeholder.url_facebook')}
            name='url_facebook'
            type='text'
            register={register}
            formState={formState}
            validate={{
              whiteSpace: true
            }}
          />
          <Input
            title={t('postulant.networks.url_twitter')}
            placeholder={t('postulant.networks.placeholder.url_twitter')}
            name='url_twitter'
            type='text'
            register={register}
            formState={formState}
            validate={{
              whiteSpace: true
            }}
          />
          <Input
            title={t('postulant.networks.urlWebsite')}
            placeholder={t('postulant.networks.placeholder.urlWebsite')}
            name='url_website'
            type='text'
            register={register}
            formState={formState}
            validate={{
              whiteSpace: true
            }}
          />
        </Grid>
      )}
      {!show && (
        <Addbutton
          fontSizeSetting={fontSizeSetting}
          onClick={() => {
            setShow(true);
          }}
        >
          {t('postulant.networks.add')}
        </Addbutton>
      )}
    </>
  );
};
